import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  loading: boolean;

  handleClose(): void;

  handleConfirmDelete(): void;
}

const ConfirmDeleteLeadListDialog: React.FC<Props> = ({ open, loading, handleClose, handleConfirmDelete }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} transitionDuration={0} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('deleteLeadListTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography className={classes.text}>{t('deleteLeadListConfirmation')}</Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} action={handleConfirmDelete} size={'small'} border={'rounded'} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
    '&.highlight': {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default ConfirmDeleteLeadListDialog;
